import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConsentProvider } from './contexts/ConsentContext';
import { useAnalytics } from './hooks/useAnalytics';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Producers from './components/Producers';
import About from './components/About';
import Contact from './components/Contact';
import ConsentBanner from './components/ConsentBanner';
import PrivacySettings from './components/PrivacySettings';
import Offer from './components/Offer';
import ChooseUs from './components/ChooseUs';
import PrivacyPolicy from './components/PrivacyPolicy';

function HomePage() {
  return (
    <>
      <Navigation />
      <main>
        <Hero />
        <Offer />
        {/* <Specialization /> */}
        <Producers />
        <About />
        <ChooseUs />
        <Contact />
      </main>
      <PrivacySettings />
    </>
  );
}

function AppContent() {
  const { trackPage } = useAnalytics();

  // Track initial page view
  React.useEffect(() => {
    trackPage(window.location.pathname, document.title);
  }, [trackPage]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
      </Routes>
      <ConsentBanner />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ConsentProvider>
        <AppContent />
      </ConsentProvider>
    </BrowserRouter>
  );
}

export default App;

